import React, { useState, useEffect, useRef } from "react";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/src/owl.carousel.css';
import 'react-owl-carousel2/src/owl.theme.default.css';
import clientConfig from "../../client-config";
import JTMSItem from "./jtmsItem";
import * as styles from './joinTheMovementSection.module.css';
import { gsap, TweenMax, Expo } from "gsap";

const options = {
    items: 4,
    nav: true,
    dots: false,
    slideTransition: 'linear',
    autoplay: true,
    autoplayTimeout: 3000,
    autoplaySpeed : 2900,
    autoplayHoverPause: false,
    freeDrag : false,
    smartSpeed: 2900,
    margin: 32,
    autoWidth:true,
    loop: true
};

function joinTheMovementSection(props) {

    const sectionRef = useRef();
    const headRef = useRef();
    const descRef = useRef();
    const owlRef = useRef();

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([headRef.current], {
        //     opacity: 0,
        //     y: 80
        // });

        // TweenMax.set([descRef.current], {
        //     opacity: 0,
        //     x: -80
        // });

        if(!$(headRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){

                    // TweenMax.to(
                    //     headRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         y: 0, 
                    //         delay : 0.25,
                    //         onComplete : () => {
                    //             $(headRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );

                    // TweenMax.to(
                    //     descRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.85,
                    //     } 
                    // );
                    $(headRef.current).addClass('anim-complete');
                }
            });
        }
        
        $(window).on('focus', function () {
            let owl = $(owlRef.current);
            $(sectionRef.current).find('.owl-next').click();
            setTimeout(() => {
                $(sectionRef.current).find('.owl-next').click();
            }, 3000);
        });

    });

    let owlClass = 'jtm-owl '+styles.owlWrap;

    return (
        <div className={styles.joinTheMovementSection} ref={sectionRef}>
            <div className={styles.sectionContainer}>
                <div className={styles.headingWrap} ref={headRef}>
                    <h2>{props.heading}</h2>
                    {
                        (props.ctaLink) ? 
                        <a className={styles.cta} href={props.ctaLink} target="_blank">
                            {props.ctaLabel}
                        </a> 
                        : ``
                    }
                </div>
            </div>
            <div className={owlClass} ref={owlRef}>
                <OwlCarousel options={options}>

                {
                    props.items.map((item, i) => {  
                        return <JTMSItem item={item} key={i} />
                    })
                }

                </OwlCarousel>
            </div>
            <div className={styles.sectionDescWrap} ref={descRef}>
                <div className={styles.sectionDesc}>
                    {props.subheading}
                </div>
            </div>
        </div>
    );
}

export default joinTheMovementSection;